import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Editor from 'common/components/modules/editor';

const EditorSection = ({
   value,
   name,
   onChange,
   sectionName,
   limit,
   ...props
}) => {
   const editorRef = useRef(null)
   const inputProps = props?.inputProps || {};
   return (
      <Editor
         { ...inputProps }
         limit={ limit }
         handleChange={ (value) => {
            onChange(name, value);
         } }
         refProps={ editorRef }
         toolbar={ ['bold', 'italic', 'underline', 'align', 'link'] }
         name={ `${ sectionName }_${ name }` }
         height={ 236 }
         initialValue={ value }
         value={ value || '' }
         variableList={ [] }
         isShowEmoji
         isShowVariableButton={ false }
         errorMessageClassName='text-xs text-end mt-2'
      />
   );
};


EditorSection.propTypes = {
   value: PropTypes.string,
   inputProps: PropTypes.object,
   onChange: PropTypes.func,
   name: PropTypes.string,
   sectionName: PropTypes.string,
   limit: PropTypes.number,
};
EditorSection.defaultProps = {
   sectionName: '',
}

export default EditorSection;
